import { comMapping } from '@/components/util/Function/comMapping';

export default {
    searchlist: [
        { prop: 'region', label: '所属区域', type: 'select', selectval: comMapping.$provinceOptions },
        {
            prop: 'archiveStatus',
            label: '归档状态',
            type: 'selectmore',
            selectval: [
                { label: '待归档', value: '0' },
                { label: '归档中', value: '1' },
                { label: '归档成功', value: '2' },
                { label: '归档异常', value: '3' }
            ]
        },
        { prop: 'declarationType', label: '申报方式', type: 'select', selectval: comMapping.$declarationMethodMapping },
        { prop: 'companyCode', label: '公司代码', type: 'input' },
        { prop: 'companyName', label: '纳税人名称', type: 'input' }
    ],
    searchdata: { region: '', archiveStatus: [], declarationType: '', companyCode: '', companyName: '', period: '' },
    pagination: { pageNum: 1, pageSize: 50, total: 0, paginationkey: 0 },
    headData: [
        { title: '所属区域', prop: 'region', width: '110' },
        { title: '纳税人名称', prop: 'companyName', width: '280' },
        { title: '公司代码', prop: 'companyCode', width: '120' },
        { title: '申报方式', prop: 'declarationType', width: '180' },
        { title: '归档状态', prop: 'archiveStatus', width: '110', custom: true },
        { title: '负责人', prop: 'responsiblePerson', width: '100' },
        { title: '待办事项', prop: 'todoScreenshot', width: '180', custom: true },
        { title: '未申报查询', prop: 'unfiledScreenshot', width: '180', custom: true },
        { title: '申报信息查询', prop: 'declarationScreenshot', width: '180', custom: true },
        { title: '财务报表信息查询', prop: 'financialScreenshot', width: '190', custom: true },
        { title: '居民企业所得税月（季）度申报', prop: 'incomeTaxScreenshot', width: '260', custom: true }
    ],
    optionalHeadData: [
        { title: '增值税及附加税(适用于一般纳税人)', prop: 'vatGeneralScreenshot', width: '280', custom: true },
        { title: '增值税及附加税(适用于小规模纳税人)', prop: 'vatSmallScaleScreenshot', width: '290', custom: true },
        { title: '企业会计准则(一般企业未执行新准则)', prop: 'accountingStandardOldScreenshot', width: '300', custom: true },
        { title: '小企业会计准则', prop: 'smallBusinessAccountingScreenshot', width: '180', custom: true },
        { title: '企业会计准则(一般企业已执行新准则)', prop: 'accountingStandardNewScreenshot', width: '300', custom: true },
        { title: '企业会计制度', prop: 'enterpriseAccountingSystemScreenshot', width: '180', custom: true },
        { title: '民间非营利组织会计制度', prop: 'nonprofitAccountingScreenshot', width: '220', custom: true },
        { title: '印花税', prop: 'stampDutyScreenshot', width: '140', custom: true },
        { title: '城镇土地使用税', prop: 'landUseTaxScreenshot', width: '180', custom: true },
        { title: '环境保护税', prop: 'environmentalProtectionTaxScreenshot', width: '160', custom: true },
        { title: '契税', prop: 'deedTaxScreenshot', width: '140', custom: true },
        { title: '房产税', prop: 'propertyTaxScreenshot', width: '140', custom: true },
        { title: '残保金', prop: 'disabilityInsuranceScreenshot', width: '140', custom: true },
        { title: '文化事业建设费', prop: 'culturalConstructionFeeScreenshot', width: '180', custom: true },
        { title: '通用申报', prop: 'generalDeclarationScreenshot', width: '140', custom: true },
        { title: '消费税及附加税', prop: 'consumptionTaxScreenshot', width: '180', custom: true }
    ]
};
